module.exports = __webpack_public_path__ + "static/acupun_2_xl-6cf70b59223ed2db48ef0c1f16567fb2.webp";